module.exports = __webpack_public_path__ + "img/example.6e7b600c.png";